export const PROYECTS_ON_GET_ALL_REQUESTED = 'PROYECTS_ON_GET_ALL_REQUESTED';
export const PROYECTS_ON_GET_ALL_SUCCEEDED = 'PROYECTS_ON_GET_ALL_SUCCEEDED';
export const PROYECTS_ON_GET_ALL_FAILED = 'PROYECTS_ON_GET_ALL_FAILED';

export const PROYECTS_ON_CREATE_REQUESTED = 'PROYECTS_ON_CREATE_REQUESTED';
export const PROYECTS_ON_CREATE_SUCCEEDED = 'PROYECTS_ON_CREATE_SUCCEEDED';
export const PROYECTS_ON_CREATE_FAILED = 'PROYECTS_ON_CREATE_FAILED';

export const PROYECTS_ON_PUT_REQUESTED = 'PROYECTS_ON_PUT_REQUESTED';
export const PROYECTS_ON_PUT_SUCCEEDED = 'PROYECTS_ON_PUT_SUCCEEDED';
export const PROYECTS_ON_PUT_FAILED = 'PROYECTS_ON_PUT_FAILED';

export const PROYECTS_ON_DELETE_REQUESTED = 'PROYECTS_ON_DELETE_REQUESTED';
export const PROYECTS_ON_DELETE_SUCCEEDED = 'PROYECTS_ON_DELETE_SUCCEEDED';
export const PROYECTS_ON_DELETE_FAILED = 'PROYECTS_ON_DELETE_FAILED';

export const PROYECTS_ON_GET_TASKS_REQUESTED = 'PROYECTS_ON_GET_TASKS_REQUESTED';
export const PROYECTS_ON_GET_TASKS_SUCCEEDED = 'PROYECTS_ON_GET_TASKS_SUCCEEDED';
export const PROYECTS_ON_GET_TASKS_FAILED = 'PROYECTS_ON_GET_TASKS_FAILED';

export const PROYECTS_ON_GET_TASKS_BY_IDS_REQUESTED = 'PROYECTS_ON_GET_TASKS_BY_IDS_REQUESTED';
export const PROYECTS_ON_GET_TASKS_BY_IDS_SUCCEEDED = 'PROYECTS_ON_GET_TASKS_BY_IDS_SUCCEEDED';
export const PROYECTS_ON_GET_TASKS_BY_IDS_FAILED = 'PROYECTS_ON_GET_TASKS_BY_IDS_FAILED';
